import { Button } from '@linearb/linui-common/marketing/Button';
import { Link } from 'react-router-dom';
import {
  StyledButtonContainr,
  StyledDivider,
  StyledFooter,
  StyledText
} from './Login.style';

export const Footer = () => (
  <StyledFooter>
    <StyledDivider />
    <StyledButtonContainr>
      <StyledText>Don't have an account?</StyledText>
      <Button
        variant='outline'
        component={Link}
        to={'register'}
        size='sm'
        sx={{ minWidth: '150px!important' }}
      >
        Sign up for free
      </Button>
    </StyledButtonContainr>
  </StyledFooter>
);
